export default __webpack_public_path__ + "static/media/default_image.2ea3fca8.png";